export const INITIAL_TOKEN_PLANS = {
  0: { amount: 25, price: '0.00', firstTimeOnly: true },
} as const

export const TOKEN_PLANS = {
  1: { amount: 50, price: '5.99' },
  2: { amount: 100, price: '9.99' },
  3: { amount: 200, price: '17.99' },
  4: { amount: 400, price: '33.99' },
} as const

export const NUM_TOKENS_PER_MESSAGE = 1
export const NUM_TOKENS_PER_IMAGE = 2
export const TOKENS_RELOAD_WITH_SUBSCRIPTION = 50
export const TOKENS_RELOAD_WITH_RECURRING = 20
export const MAX_SUBSCRIPTION_TOKENS = 100
/** One-time token allotment credited when an admin sets a user's role to affiliate. */
export const AFFILIATE_INITIAL_TOKENS = 100

export type TokenPlanId = keyof typeof TOKEN_PLANS
export type InitialPlanId = keyof typeof INITIAL_TOKEN_PLANS

type TokenOption = {
  id: number
  amount: number
  price: string
  firstTimeOnly?: boolean
}

export const tokenOptions: TokenOption[] = Object.entries(TOKEN_PLANS).map(([id, plan]) => ({
  id: Number(id),
  amount: plan.amount,
  price: plan.price,
  firstTimeOnly: false,
}))

export const initialTokenOptions: TokenOption[] = Object.entries(INITIAL_TOKEN_PLANS).map(
  ([_, plan]) => ({
    id: 0, // Use 0 for free plan
    amount: plan.amount,
    price: plan.price,
    firstTimeOnly: plan.firstTimeOnly,
  })
)

export function getAvailableTokenOptions(hasClaimedInitialTokens: boolean) {
  if (!hasClaimedInitialTokens) {
    // Show free 50 tokens instead of paid 50 tokens when showing initial options
    const regularOptions = tokenOptions.filter((opt) => opt.id !== 1)
    return [...initialTokenOptions, ...regularOptions].sort((a, b) => a.amount - b.amount)
  }

  // If they've already claimed initial tokens, only show regular options
  return tokenOptions
}

export function getAllTokenOptions() {
  return [...initialTokenOptions, ...tokenOptions].sort((a, b) => a.amount - b.amount)
}
